import {
    RequestConfigFunction,
} from 'app/types/request.types'

type OrderNotificationSettingsRequests = {
    get: RequestConfigFunction<{id: number}>,
    update: RequestConfigFunction<Record<string, any> & {id: number}>,
}

const orderNotificationSettingsRequests: OrderNotificationSettingsRequests = {
    get: ({
        id,
    }) => {
        return {
            url: `lane/${id}/notifications-settings`,
            method: 'GET',
        }
    },
    update: ({
        id,
        ...params
    }) => {
        return {
            url: `lane/${id}/notifications-settings`,
            method: 'PATCH',
            ...params,
        }
    },
}

export default orderNotificationSettingsRequests
